export type LmdDdScheduleEntry = {
  employee_details: {
    emp_id: string;
    [key: string]: unknown;
  };
  customer_visits: Array<{
    outlet_id?: string;
    outlet_name_en?: string;
    sequence?: number;
    latitude?: string | number;
    longitude?: string | number;
    check_in_latitude?: string | number;
    check_in_longitude?: string | number;
    outcome_status?: string;
    is_planned_visit?: boolean;
    [key: string]: unknown;
  }>;
  planned_route_details?: {
    origin?: { lat: string; lng: string };
    destination?: { lat: string; lng: string };
    waypoints?: Array<{
      location: { lat: string; lng: string };
      stopover: boolean;
    }>;
    directions?: {
      routes?: Array<{
        duration?: string;
        polyline?: {
          encodedPolyline?: string;
        };
        distanceMeters?: number;
      }>;
    };
  };
};

const SAUDI_LAT_MIN = 15;
const SAUDI_LAT_MAX = 34;
const SAUDI_LNG_MIN = 33;
const SAUDI_LNG_MAX = 61;

export const isValidMapCoordinate = (
  latitude: unknown,
  longitude: unknown
): boolean => {
  const lat = Number(latitude);
  const lng = Number(longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  if (lat === 0 && lng === 0) return false;
  if (lat < SAUDI_LAT_MIN || lat > SAUDI_LAT_MAX) return false;
  if (lng < SAUDI_LNG_MIN || lng > SAUDI_LNG_MAX) return false;

  return true;
};

export const getPlannedVisitPosition = (visit: LmdDdScheduleEntry["customer_visits"][number]) => {
  if (isValidMapCoordinate(visit.latitude, visit.longitude)) {
    return {
      lat: Number(visit.latitude),
      lng: Number(visit.longitude),
    };
  }

  return null;
};

export const normalizeDdScheduleResponse = (payload: unknown): LmdDdScheduleEntry[] => {
  if (Array.isArray(payload)) return payload as LmdDdScheduleEntry[];
  if (
    payload &&
    typeof payload === "object" &&
    Array.isArray((payload as { data?: unknown }).data)
  ) {
    return (payload as { data: LmdDdScheduleEntry[] }).data;
  }
  return [];
};

export const LMD_ROUTE_COLORS = [
  "#00A39E",
  "#870091",
  "#3366FF",
  "#FF4D68",
  "#FFAA2A",
  "#00C48C",
  "#9B59B6",
  "#E67E22",
];
